export default function AboutSection() {
  return (
    <section id="about" data-testid="about-section" className="py-20 md:py-32">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="reveal reveal-up">
            <p className="text-xs uppercase tracking-[0.3em] text-[#EAB308] mb-4">
              Náš příběh
            </p>
            <h2 className="font-['Playfair_Display'] text-3xl md:text-5xl font-semibold text-[#F0FDF4] mb-8 tracking-tight">
              O nás
            </h2>
            <div className="space-y-5 text-[#94A3B8] leading-relaxed">
              <p>
                Vítejte ve <span className="text-[#F0FDF4] font-medium">Verandě pod Soutokem</span> —
                místě, kde se potkává ta nejlepší česká a ukrajinská tradice.
                Naše jídla připravujeme z čerstvých, místních surovin s láskou
                a respektem k tradičním recepturám.
              </p>
              <p>
                Přes den nabízíme <span className="text-[#EAB308]">dostupná obědová menu</span> ideální
                pro rychlý a sytý oběd. Večer se naše restaurace promění
                v příjemné místo pro posezení s rodinou či přáteli u výběrového
                večerního menu.
              </p>
              <p>
                Přijďte ochutnat naše speciality — od klasické svíčkové
                až po pravý ukrajinský boršč. Těšíme se na vás!
              </p>
            </div>

            <div className="flex justify-center gap-12 mt-10">
              <div>
                <span className="text-3xl font-bold text-[#EAB308] font-['Playfair_Display']">7+</span>
                <p className="text-sm text-[#94A3B8] mt-1">let tradice</p>
              </div>
              <div>
                <span className="text-3xl font-bold text-[#EAB308] font-['Playfair_Display']">2 v 1</span>
                <p className="text-sm text-[#94A3B8] mt-1">to nejlepší z Česka i Ukrajiny</p>
              </div>
              <div>
                <span className="text-3xl font-bold text-[#EAB308] font-['Playfair_Display']">100%</span>
                <p className="text-sm text-[#94A3B8] mt-1">poctivost</p>
              </div>
            </div>
          </div>
        </div>
    </section>
  );
}
